<template>
    <div class="menu__header">
        <img src="../assets/logo.svg" alt="PagoUno Logo">
    </div>
    <div class="menu__body">
        <DxTreeView
        :data-source="menuItems"      
        :select-by-click="true"
        selection-mode="single"
        @item-selection-changed="optionSelect"
        class="panel-list"/>
    </div>
    <div class="menu__footer">
        <div class="content">
            <p>matias alvarez</p>
            <p>Inicio sesión: 2021/04/14</p>
        </div>
        <!-- 
          -- ToDo
          -- Logout
         -->
        <DxButton
            text="Cerrar sesión"
            type="normal"
            styling-mode="outlined"
            @click="$router.push('/')"
        />
    </div>
</template>

<script>
    /**
    * Importaciones devExtreme
    */
    import DxTreeView from 'devextreme-vue/tree-view'
    import DxButton from 'devextreme-vue/button';

    /**
     * Importaciones Vue
     */
    import { computed } from 'vue'
    import { useStore } from 'vuex'

    export default {
        name: 'Menu',
        components: {
            DxTreeView,
            DxButton
        },
        setup() {
            const store = useStore();

            /**
             * COMPUTED PROPERTIES
             */
            const menuItems = computed( () => store.state.menuItems );

            /**
             * METHODS
             */
            const optionSelect = async (e) => {
                if(e.itemData.id.includes('_')){
                    await store.dispatch('changeOption', e.itemData);
                    await store.dispatch('get',
                    {option: store.state.optionSelect.text, page: 1})
                    store.dispatch('changePage',1)
                }
            };

            return { 
                menuItems, 
                optionSelect
            }
        }
    }
</script>

<style>
.menu {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.menu__header {
    padding: 20px 10px;
    text-align: center;
}
.menu__header img{
    max-width: 180px;
}
.menu__body {
    padding-left: 10px;
    flex-grow: 1;
}
.menu__footer {
    display: flex;
    flex-direction: column;
    padding: 20px 15px;
}

.menu__footer .content {
    margin-bottom: 15px;
}

.menu__footer .content p:last-child{
    text-transform: lowercase;
    font-style: italic;
    font-weight: 300;
    margin-top: 5px;
}
.menu__footer .content p:first-child{
    text-transform: uppercase;
}
</style>